export default "__VITE_ASSET__DFsKzlIP__"